module.exports = __webpack_public_path__ + "static/img/msg_null.c7360397.jpg";